import script from "./salesreturnlist.vue?vue&type=script&setup=true&lang=js"
export * from "./salesreturnlist.vue?vue&type=script&setup=true&lang=js"

import "./salesreturnlist.vue?vue&type=style&index=0&id=38e80f0c&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e80f0c"]])

export default __exports__